import { TDataCategory } from '@app/factory/categoryList';
import { TFlatJsonStruct } from '@app/factory/flatJson';
import { GridApi } from 'ag-grid-community';
import { action, IObservableArray, IObservableValue, makeObservable, observable, ObservableSet } from 'mobx';

export class TranslateStore {
    gridApi: GridApi = null;

    autoSizeColumns() {
        this.gridApi.sizeColumnsToFit();
    }
    constructor() {
        makeObservable(this);
    }

    @observable mainLanguageId: string = '';
    @observable targetLanguageId: string = '';

    @observable tableNarrow: boolean = true;

    @observable categoryOpen: boolean = false;
    @observable hideWords: boolean = false;
    @observable changeWords: boolean = false;
    @observable open: boolean = false;
    @observable openAlert: boolean = false;
    @observable openModalSuccess: boolean = false;
    @observable openModalError: boolean = false;
    @observable openConfirm: boolean = false;
    @observable openConfirmModalSuccess: boolean = false;
    @observable openConfirmModalError: boolean = false;
    @observable openReject: boolean = false;
    @observable openRejectModalSuccess: boolean = false;
    @observable openRejectModalError: boolean = false;
    @observable confirmChange: boolean = false;
    @observable confirmSave: boolean = false;
    @observable confirmTempFilesToDelete: boolean = true;

    @observable eventNewValue: string = '';
    @observable eventOldValue: string = '';

    categoryData: IObservableArray<TDataCategory> = observable.array([], { deep: false });
    gridDate: IObservableArray<TFlatJsonStruct> = observable.array([], { deep: false });
    nextWordsKey: string;
    changeSet: ObservableSet<any> = observable.set([]);
    changeSetBeforeAccept: ObservableSet<any> = observable.set([]);
    changeSetRest: ObservableSet<any> = observable.set([]);
    filteredSet: ObservableSet<any> = observable.set([]);
    sameValueArr: IObservableArray<TFlatJsonStruct> = observable.array([], { deep: false });

    eventDataArr: IObservableValue<TFlatJsonStruct> = observable.box(null, { deep: false });

    @action
    clear() {
        this.mainLanguageId = '';
        this.targetLanguageId = '';
        this.categoryOpen = false;
        this.hideWords = false;
        this.changeWords = false;
        this.confirmTempFilesToDelete = true;
        //render
        this.categoryData.clear();
        this.gridDate.clear();
        this.changeSet.clear();
        this.changeSetRest.clear();
        this.filteredSet.clear();
        //render
    }

    @action
    handleOpen() {
        this.confirmChange = false;
        this.open = !this.open;
    }

    @action
    handleClose() {
        this.open = false;
    }

    @action
    handleConfirmed(confirm) {
        if (confirm == true) {
            this.sameValueArr.forEach((rowNode) => {
                rowNode.translate = this.eventNewValue;
                this.changeSetRest.add(rowNode.key);
            });
        } else {
            this.changeSet.add(this.eventDataArr.get().value);
        }
        this.gridApi.redrawRows();
    }

    @action
    handleOpenConfirm() {
        this.openConfirm = !this.openConfirm;
        this.confirmTempFilesToDelete = true;
    }

    @action
    handleCloseConfirm() {
        this.openConfirm = false;
        this.confirmTempFilesToDelete = true;
    }

    @action
    handleCloseConfirmDone() {
        this.openConfirm = false;
        this.handleOpenConfirmModalSuccess();
    }

    @action
    handleOpenReject() {
        this.openReject = !this.openReject;
        this.confirmTempFilesToDelete = true;
    }

    @action
    handleCloseReject() {
        this.openReject = false;
        this.confirmTempFilesToDelete = true;
    }

    @action
    handleCloseRejectDone() {
        this.openReject = false;
        this.handleOpenRejectModalSuccess();
    }

    @action
    handleOpenAlert() {
        this.openAlert = !this.openAlert;
    }

    @action
    handleCloseAlertNo() {
        this.openAlert = false;
    }

    @action
    handleCloseAlertYes() {
        this.openAlert = false;
    }

    @action
    handleOpenModalSuccess() {
        this.openModalSuccess = !this.openModalSuccess;
        this.changeSet.clear();
    }

    @action
    handleCloseModalSuccess() {
        this.openModalSuccess = false;
        this.changeSet.clear();
    }

    @action
    handleOpenModalError() {
        this.openModalError = !this.openModalError;
    }

    @action
    handleCloseModalError() {
        this.openModalError = false;
    }

    @action
    handleOpenConfirmModalSuccess() {
        this.openConfirmModalSuccess = !this.openConfirmModalSuccess;
    }

    @action
    handleCloseConfirmModalSuccess() {
        this.openConfirmModalSuccess = false;
    }

    @action
    handleOpenConfirmModalError() {
        this.openConfirm = false;
        this.openConfirmModalError = !this.openConfirmModalError;
    }

    @action
    handleCloseConfirmModalError() {
        this.openConfirmModalError = false;
    }

    @action
    handleOpenRejectModalSuccess() {
        this.openRejectModalSuccess = !this.openRejectModalSuccess;
    }

    @action
    handleCloseRejectModalSuccess() {
        this.openRejectModalSuccess = false;
    }

    @action
    handleOpenRejectModalError() {
        this.openReject = false;
        this.openRejectModalError = !this.openRejectModalError;
    }

    @action
    handleCloseRejectModalError() {
        this.openRejectModalError = false;
    }
}
